<button id="{{optionId}}" class="dropdown-item" (click)="raiseClick($event)">{{text}}</button>